<template>
    <div>
        <a-table :columns="columns" row-key="id" :pagination="false"
                 :loading="tableLoading"
                 :dataSource="tableDataSource">
            <div slot="student" slot-scope="text">
                {{text.settingUserCount}}/{{text.courseChildUserCount}}
            </div>
            <div slot="action" class="action" slot-scope="text">
                <a @click="setStudent(text)">配置学生</a>
                <a-popconfirm title="确认删除此课程？" @confirm="delCourse(text)">
                    <a class="red">删除</a>
                </a-popconfirm>
            </div>
        </a-table>

        <!-- 配置学生 -->
        <a-modal v-model="student.visible" title="配置学生" @cancel="handleCancel" width="70%" :centered="true"
                 :destroyOnClose="true">
            <template slot="footer">
                <div v-if="student.step == 1">
                    <a-button @click="student.visible = false">
                        取消
                    </a-button>
                    <a-button :loading="student.confirmLoading" type="primary" @click="next(2)">
                        下一步
                    </a-button>
                </div>
                <div v-if="student.step == 2">
                    <a-button @click="next(1)">
                        上一步
                    </a-button>
                    <a-button :loading="student.confirmLoading" type="primary" @click="studentSubmit()">
                        确定
                    </a-button>
                </div>
            </template>
            <a-spin :spinning="student.loading" style="min-height: 300px;">
                <a-form-model
                        ref="ruleForm"
                        :model="student.form"
                        :rules="student.rules"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 10 }">
                    <template v-if="student.step == 1">
                        <a-form-model-item label="完成状态" prop="status">
                            <a-checkbox-group v-model="student.form.status" @change="setStudent(courseChildItem)">
                                <a-checkbox :value="2" name="type">已完成</a-checkbox>
                                <a-checkbox :value="1" name="type">进行中</a-checkbox>
                                <a-checkbox :value="0" name="type">未开始</a-checkbox>
                            </a-checkbox-group>
                        </a-form-model-item>
                        <a-form-model-item label="班级选择" prop="checkedKeys">
                            <a-tree checkable :key="student.treeKey"
                                    :replaceFields="{children:'childs', title:'gradeClassName', key:'gradeClassID'}"
                                    :defaultExpandAll="true"
                                    :tree-data="student.treeData"
                                    v-model="student.form.checkedKeys"/>
                        </a-form-model-item>
                    </template>
                    <template v-if="student.step == 2">
                        <a-form-model-item label="班级选择" prop="checkedKeys">
                            <a-tree :replaceFields="{children:'childs', key:'gradeClassID'}"
                                    :key="student.treeKey"
                                    :defaultExpandAll="true"
                                    :tree-data="student.treeData1"/>
                        </a-form-model-item>
                    </template>
                </a-form-model>
            </a-spin>
        </a-modal>
    </div>
</template>

<script>
    export default {
        name: "StepsSecondAddCourse",
        props: {
            tableDataSource: Array,
            tableLoading: {
                type: Boolean,
                default: false
            },
            IsDetails: {
                type: Boolean,
                default: false
            },
            organization: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                columns: [
                    {title: '测评名称', dataIndex: 'projectCourseConfigName'},
                    {title: '资源名称', dataIndex: 'courseName'},
                    {title: '课时名称', dataIndex: 'childCourseName'},
                    {title: '学生数', scopedSlots: {customRender: 'student'}},
                    {title: '操作', scopedSlots: {customRender: 'action'}},
                ],
                student: {
                    visible: false,
                    loading: false,
                    confirmLoading: false,
                    setStatus: false,
                    step: 1,
                    form: {
                        status: [2],
                        checkedKeys: []
                    },
                    treeKey: Date.now(),
                    treeData: [],
                    treeData2: [],
                    rules: {
                        status: [
                            {type: 'array', required: true, message: '请选择完成状态', trigger: 'change'},
                        ],
                        checkedKeys: [
                            {type: 'array', required: true, message: '请选择班级', trigger: 'change'},
                        ]
                    }
                },
                courseChildItem: {},
            }
        },
        created() {
            if (this.organization && this.columns.length <= 5) {
                this.columns.unshift({title: '机构名称', dataIndex: 'organizationName'})
            }
            if (this.IsDetails && this.columns.length > 4){
                this.columns.pop();
            }
        },
        methods: {
            // 配置学生
            setStudent(text) {
                console.log(this.student.form.status)
                this.courseChildItem = text;
                this.student.visible = true;
                const Params = {
                    CompletionStatus: this.student.form.status,
                    GroupReportCourseId: this.courseChildItem.id,
                    step:0
                };
                this.student.loading = true;
                this.$http.GroupReport.getGroupReportCourseSettings(Params).then(res => {
                    if (!this.student.setStatus && res.data.participantConfig.completionStatus.length) {
                        this.student.setStatus = true;
                        this.student.form.status = res.data.participantConfig.completionStatus;
                    }
                    if (!res.data.statistics.courseChildUserCount){
                        return
                    }
                    this.student.form.checkedKeys = res.data.participantConfig.classIds;
                    this.student.treeData = [{
                        gradeClassID: "0",
                        gradeClassName: "全部",
                        courseChildUserCount: res.data.statistics.courseChildUserCount,
                        childs: res.data.statistics.gradeClasss.map(m => {
                            m.gradeClassID = m.gradeClassID + "";
                            return m;
                        })
                    }];
                    this.student.treeKey = Date.now();
                }).finally(() => {
                  this.student.loading = false;
                })
            },
            // 删除课程
            delCourse(val) {
                const Form = new FormData();
                Form.append("id", val.id);
                this.$emit("loading", true);
                this.$http.GroupReport.deleteCourseChild(Form).then(res => {
                    this.$emit("loading", false);
                    this.$message.success(res.message);
                    this.$emit("renewData");
                });
            },
            handleCancel() {
                console.log(this.student.form.status)
                this.student = {
                    ...this.student,
                    step: 1,
                    form: {
                        status: [2],
                        checkedKeys: []
                    },
                    treeKey: Date.now(),
                    treeData: [],
                    setStatus: false
                }
                console.log(this.student.form.status)
            },
            next(num) {
                if (num == 1) {
                    this.student.step = num;
                    return
                }
                this.$refs["ruleForm"].validate(valid => {
                    if (valid) {
                        const Params = {
                            CompletionStatus: this.student.form.status,
                            classIds: this.student.form.checkedKeys.filter(f => typeof f === "number"),
                            GroupReportCourseId: this.courseChildItem.id,
                            step:1
                        };
                        this.student.confirmLoading = true;
                        this.$http.GroupReport.getGroupReportCourseSettings(Params).then(res => {
                            this.student.treeData1 = [{
                                gradeClassID: "0",
                                title: `全部(${res.data.statistics.settingUserCount}/${res.data.statistics.courseChildUserCount})`,
                                childs: setArr(res.data.statistics.gradeClasss)
                            }];
                            this.student.step = num;
                            this.student.treeKey = Date.now();
                        }).finally(() => {
                          this.student.confirmLoading = false;
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

                function setArr(arr) {
                    return arr.map(m => {
                        m.title = m.gradeClassName + `(${m.settingUserCount}/${m.courseChildUserCount})`;
                        m.childs = setArr(m.childs);
                        return m;
                    })
                }
            },
            // 配置学生
            studentSubmit() {
                const RequestBody = {
                    groupReportProjectChildCourseId: this.courseChildItem.id,
                    config: {
                        ...this.uniformity,
                        completionStatus: this.student.form.status,
                        classIds: this.student.form.checkedKeys.filter(f => typeof f !== "string")
                    }
                };
                this.student.confirmLoading = true;
                this.$http.GroupReport.updateParticipantConfig(RequestBody).then(res => {
                    this.student.visible = false;
                    this.student.step = 1;
                    this.student.setStatus = false;
                    this.student.form.status = [2];
                    this.student.form.checkedKeys = [];
                    this.$message.success(res.message);
                    this.$emit("renewData");
                }).finally(() => {
                  this.student.confirmLoading = false;
                })
            },
        }
    }
</script>

<style scoped>
    .search-item {
        width: 180px;
        margin-bottom: 15px;
    }
</style>
